import type { SVGProps } from "react";
export interface BlockchainIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BlockchainIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BlockchainIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.753 15.622a1.125 1.125 0 0 1 .993 2.014L3.55 19.981a1.125 1.125 0 0 1-1.098-1.962l4.198-2.346.104-.05Zm9.067.483c.284-.508.904-.71 1.427-.484l.104.05 4.198 2.348a1.125 1.125 0 1 1-1.097 1.962l-4.198-2.345-.098-.061a1.125 1.125 0 0 1-.336-1.47M10.875 8.5V4a1.126 1.126 0 0 1 2.25 0v4.5a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M3.217 16.887a2.125 2.125 0 1 1-2.332 2.33l-.01-.216.01-.219A2.126 2.126 0 0 1 3 16.875zm18 0a2.125 2.125 0 1 1-2.332 2.33l-.01-.216.01-.219A2.126 2.126 0 0 1 21 16.875zm-5.342-3.895-2.75 1.57v3.303l2.31-1.318a.88.88 0 0 0 .44-.76zm-3.44-3.252a.88.88 0 0 0-.87 0l-2.298 1.312 2.734 1.563 2.731-1.561zm-.218-7.855a2.126 2.126 0 1 1-2.332 2.332L9.875 4l.01-.218a2.126 2.126 0 0 1 2.116-1.907zM8.125 15.787c0 .313.168.604.44.76l2.31 1.318v-3.303l-2.75-1.57zm10 0A3.13 3.13 0 0 1 16.55 18.5l-3 1.714a3.12 3.12 0 0 1-3.1 0l-3-1.714a3.13 3.13 0 0 1-1.575-2.714v-3.573A3.12 3.12 0 0 1 7.45 9.5l3-1.714a3.13 3.13 0 0 1 3.1 0l3 1.714a3.13 3.13 0 0 1 1.575 2.713z"
      />
    </svg>
  );
}
